import { Types } from '@store/types';

import ApiClient from '@lib/apiClient';

export const fetchOrderStyleNumberList =
	(params = '') =>
	async (dispatch) => {
		await ApiClient.GET('getOrderStyles', `?page=0&size=30&search=${params}`).then((response) => {
			dispatch({
				type: Types.STORE_ORDER_STYLE_LIST,
				payload: response.data.data
			});
		});
	};

export const fetchPONumberList =
	(params = '') =>
	async (dispatch) => {
		await ApiClient.GET('getPoNumbers', `?page=0&size=30&search=${params}`).then((response) => {
			dispatch({
				type: Types.STORE_ORDER_PO_LIST,
				payload: response.data.data
			});
		});
	};

export const fetchOrderTitleList =
	(params = '') =>
	async (dispatch) => {
		await ApiClient.GET('getOrders', `?page=0&size=30&search=${params}`).then((response) => {
			dispatch({
				type: Types.STORE_ORDER_TITLE_LIST,
				payload: response.data.data
			});
		});
	};

export const fetchFactoryList =
	(params = '') =>
	async (dispatch) => {
		await ApiClient.GET('getFactories', `?page=0&size=30&search=${params}`).then((response) => {
			dispatch({
				type: Types.STORE_FACTORY_LIST,
				payload: response.data.data
			});
		});
	};

export const fetchSalesContractList =
	(params = '') =>
	async (dispatch) => {
		await ApiClient.GET('getSalesContracts', `?page=0&size=30&search=${params}`).then((response) => {
			dispatch({
				type: Types.STORE_SALES_CONTRACT_LIST,
				payload: response.data.data
			});
		});
	};

export const fetchCommercialInvoiceList =
	(params = '') =>
	async (dispatch) => {
		await ApiClient.GET('getCommercialInvoices', `?page=0&size=30&search=${params}`).then((response) => {
			dispatch({
				type: Types.STORE_COMMERCIAL_INVOICE_LIST,
				payload: response.data.data
			});
		});
	};
